document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest('.product-drawers-open-button');
  if (!button) return;

  const drawerId = button.getAttribute('aria-controls') || 'description-content';
  const drawer = document.getElementById(drawerId);

  if (!drawer) {
    console.warn(`Drawer #${drawerId} was not found.`);
    return;
  }

  event.preventDefault();

  if (drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  OverlayManager.open(drawer);
  button.setAttribute('aria-expanded', 'true');
});